import { cn } from '@/utils/tailwind';

interface SkeletonProps {
  className?: string;
  style?: React.CSSProperties;
}

export const Skeleton: React.FC<SkeletonProps> = ({ className, style }) => {
  return (
    <div
      className={cn(
        'my-2 h-4 w-full animate-pulse rounded bg-tertiary',
        className
      )}
      style={style}
    />
  );
};

export const SkeletonRows = ({
  rows,
  className,
  skeletonClassName,
}: {
  rows: number;
  className?: string;
  skeletonClassName?: string;
}) => {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton key={index} className={skeletonClassName} />
      ))}
    </div>
  );
};

export const CircleSkeleton = ({ className, style }: SkeletonProps) => {
  return (
    <div
      className={cn(
        'my-2 h-5 w-5 animate-pulse rounded-full bg-tertiary',
        className
      )}
      style={style}
    />
  );
};
